import { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import api from "../api/client.js";
import { useI18n } from "../i18n/I18nContext.jsx";

export default function ZoneForm({ zone, onClose, onSuccess }) {
  const { t } = useI18n();
  const isEdit = !!zone;

  const [formData, setFormData] = useState({
    name: "",
    code: "",
    cug_number: "",
    ac_office: "",
  });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (zone) {
      setFormData({
        name: zone.name || "",
        code: zone.code || "",
        cug_number: zone.cug_number || "",
        ac_office: zone.ac_office || "",
      });
    }
  }, [zone]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      if (isEdit) {
        await api.put(`/zones/${zone.id}/`, formData);
      } else {
        await api.post("/zones/", formData);
      }
      onSuccess();
    } catch (err) {
      console.error("ZoneForm error:", err);
      const msg = err.response?.data?.detail || "Failed to save zone.";
      if (typeof err.response?.data === 'object' && err.response?.data?.name) {
          setError(err.response.data.name[0]);
      } else if (typeof err.response?.data === 'object' && err.response?.data?.code) {
          setError(err.response.data.code[0]);
      } else {
          setError(msg);
      }
    } finally {
      setLoading(false);
    }
  };

  return createPortal(
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 500 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
          <h2 style={{ margin: 0 }}>{isEdit ? t("editZone") : t("addZone")}</h2>
          <button className="btn btn-outline" style={{ padding: "4px 8px" }} onClick={onClose}>
            &times;
          </button>
        </div>
        <form onSubmit={handleSubmit} className="form-grid">
          {error && (
            <div className="alert alert-error" style={{ gridColumn: "1 / -1" }}>
              {error}
            </div>
          )}

          <div className="form-group" style={{ gridColumn: "1 / -1" }}>
            <label>{t("zone")} Name *</label>
            <input
              type="text"
              name="name"
              required
              value={formData.name}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>{t("code")} *</label>
            <input
              type="text"
              name="code"
              required
              value={formData.code}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>{t("cugNumber")}</label>
            <input
              type="text"
              name="cug_number"
              value={formData.cug_number}
              onChange={handleChange}
            />
          </div>

          <div className="form-group" style={{ gridColumn: "1 / -1" }}>
            <label>{t("acOffice")}</label>
            <input
              type="text"
              name="ac_office"
              value={formData.ac_office}
              onChange={handleChange}
            />
          </div>

          <div className="modal-actions" style={{ gridColumn: "1 / -1" }}>
            <button type="button" className="btn btn-outline" onClick={onClose}>
              {t("cancel")}
            </button>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? t("loading") : t("save")}
            </button>
          </div>
        </form>
      </div>
    </div>,
    document.body
  );
}
